export const SHOW_MESSAGE_POPOVER = 'message/SHOW_MESSAGE_POPOVER';
export const SET_UNREAD_MESSAGE_COUNT = 'message/SET_UNREAD_MESSAGE_COUNT';

const initialState = {
    openMessagePopOver: false,
    unreadMessageCount: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SHOW_MESSAGE_POPOVER:
            return {
                ...state,
                openMessagePopOver: action.open
            };
        case SET_UNREAD_MESSAGE_COUNT:
            return {
                ...state,
                unreadMessageCount: action.count
            };
        default:
            return state
    }
}

export const showMessagePopover = (open) => {
    return dispatch => {
        dispatch({
            type: SHOW_MESSAGE_POPOVER,
            open: open
        });
    }
};

export const setUnreadMessageCount = (count) => {
    return dispatch => {
        dispatch({
            type: SET_UNREAD_MESSAGE_COUNT,
            count: count
        });
    }
};